import MemberActionAssignBadge from '@/screens/MemberActionAssignBadge';

export default MemberActionAssignBadge;
